import { keyframes } from '@emotion/react';

/** 페이지 전반 공통 duration / easing (CSS transition·animation) */
export interface MotionTokens {
	duration: {
		fast: string;
		normal: string;
		slow: string;
		slower: string;
	};
	easing: {
		standard: string;
		decelerate: string;
		accelerate: string;
	};
}

export const motion: MotionTokens = {
	duration: {
		fast: '0.15s',
		normal: '0.22s',
		slow: '0.32s',
		slower: '0.45s',
	},
	easing: {
		standard: 'cubic-bezier(0.4, 0, 0.2, 1)',
		decelerate: 'cubic-bezier(0, 0, 0.2, 1)',
		accelerate: 'cubic-bezier(0.4, 0, 1, 1)',
	},
};

export const fadeInUp = keyframes`
	from {
		opacity: 0;
		transform: translateY(10px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
`;
